<script setup>
import SvgIcon from '@jamescoyle/vue-icon'
import {mdiAlertCircleOutline} from "@mdi/js";
</script>

<template>
<div class="data-list-item p-8 flex flex-column align-items-center">
    <div class="text-500 mb-4">
        <svg-icon type="mdi" :path="mdiAlertCircleOutline" :size="64" class="block" />
    </div>
    <div>
        <slot />
    </div>
</div>
</template>

<style scoped lang="scss">

</style>
